const dateStartNamesForTypes = {
  EMAIL: 'StartEmail',
  PUSH: 'StartPush',
  PHONE: 'StartPhone',
  SMS: 'StartSms',
};

export default dateStartNamesForTypes;
